// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field-form .form-group.checkbox[data-v-41b1110a] {\n  margin-bottom: 20px;\n}\n.field-form__type[data-v-41b1110a] {\n  padding-top: 6px;\n}\n.no-types[data-v-41b1110a] {\n  color: #8e9cbb;\n}\n[data-v-41b1110a] .used {\n  font-size: 11px;\n}\n", ""]);
// Exports
module.exports = exports;
